export const isMainPage = (): boolean => location.pathname === '/';
